import Form from 'components/form';
import Input from 'components/form/TextInput';
import React from 'react';
import { useForm } from './Form';
const { FormItem } = Form;

const NumberInput = ({ id, required, inputProps }) => {
  const { getFieldDecorator } = useForm();

  return (
    <FormItem>
      {getFieldDecorator(id, {
        rules: [{ required, message: 'Required' }],
      })(
        <Input
          fullWidth
          inputProps={inputProps}
          type="number"
          margin="dense"
        />,
      )}
    </FormItem>
  );
};

export default NumberInput;
